import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/mails', {
      params,
    })
    return response.data.data
  },

  async get(params) {
    let response = await api.get('/admin/mails/detail', {
      params,
    })
    return response.data.data.document || null
  },

  async create(payload) {
    const response = await api.post('/admin/mails', payload)
    return response || null
  },

  async update(payload) {
    const response = await api.put('/admin/mails', payload)
    return response || null
  },

  async delete(payload) {
    const response = await api.delete('/admin/mails', {
      data: payload,
    })
    return response
  },
}
